import { render, staticRenderFns } from "./MomentList.vue?vue&type=template&id=0b1c123e&scoped=true"
import script from "./MomentList.vue?vue&type=script&lang=js"
export * from "./MomentList.vue?vue&type=script&lang=js"
import style0 from "./MomentList.vue?vue&type=style&index=0&id=0b1c123e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c123e",
  null
  
)

export default component.exports